export const NIGHT_MODE_STORAGE_KEYS = {
  manualEnabled: 'manualNightMode',
  mode: 'nightModeMode',
  // 手动切换时记录“当下所处的自动窗口”，用于跨过下一个切换点后自动恢复自动模式
  manualBaseline: 'nightModeManualBaseline'
};

export const NIGHT_MODE_MODE = {
  auto: 'auto',
  manual: 'manual'
};

export function isInAutoNightWindow(now = new Date()) {
  const hour = now.getHours();
  const minute = now.getMinutes();
  const currentMinutes = hour * 60 + minute;
  const startMinutes = 18 * 60; // 18:00
  const endMinutes = 7 * 60 + 30; // 07:30
  return currentMinutes >= startMinutes || currentMinutes < endMinutes;
}

export function getNightModeMode() {
  const mode = localStorage.getItem(NIGHT_MODE_STORAGE_KEYS.mode);
  return mode === NIGHT_MODE_MODE.manual ? NIGHT_MODE_MODE.manual : NIGHT_MODE_MODE.auto;
}

export function setNightModeMode(mode) {
  localStorage.setItem(
    NIGHT_MODE_STORAGE_KEYS.mode,
    mode === NIGHT_MODE_MODE.manual ? NIGHT_MODE_MODE.manual : NIGHT_MODE_MODE.auto
  );
}

export function getManualNightModeEnabled() {
  return localStorage.getItem(NIGHT_MODE_STORAGE_KEYS.manualEnabled) === 'true';
}

export function setManualNightModeEnabled(enabled) {
  localStorage.setItem(NIGHT_MODE_STORAGE_KEYS.manualEnabled, String(!!enabled));
}

// 进入手动模式：记录手动选择 + 当下的自动窗口基线（供到下个切换点自动恢复用）
export function activateManualNightMode(enabled, now = new Date()) {
  setNightModeMode(NIGHT_MODE_MODE.manual);
  setManualNightModeEnabled(enabled);
  localStorage.setItem(NIGHT_MODE_STORAGE_KEYS.manualBaseline, String(isInAutoNightWindow(now)));
}

// 恢复自动模式：清掉手动基线
export function resumeAutoNightMode() {
  setNightModeMode(NIGHT_MODE_MODE.auto);
  localStorage.removeItem(NIGHT_MODE_STORAGE_KEYS.manualBaseline);
}

export function resolveNightModeEnabled(now = new Date()) {
  const auto = isInAutoNightWindow(now);
  if (getNightModeMode() !== NIGHT_MODE_MODE.manual) {
    return auto;
  }
  // 手动仅作一次性临时覆盖：跨过下一个自动切换点(18:00 / 07:30)后自动恢复自动模式。
  // baseline 缺失（老版本遗留的“永久手动”，或曾被卡死的用户）一律视为到期，直接恢复自动。
  const baseline = localStorage.getItem(NIGHT_MODE_STORAGE_KEYS.manualBaseline);
  if (baseline === null || String(auto) !== baseline) {
    resumeAutoNightMode();
    return auto;
  }
  return getManualNightModeEnabled();
}
